import { render, staticRenderFns } from "./ForgotPasswordManaus.vue?vue&type=template&id=6fd2fa27&scoped=true"
import script from "./ForgotPasswordManaus.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordManaus.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordManaus.vue?vue&type=style&index=0&id=6fd2fa27&prod&scoped=true&lang=css"
import style1 from "./ForgotPasswordManaus.vue?vue&type=style&index=1&id=6fd2fa27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2fa27",
  null
  
)

export default component.exports